module.exports = __webpack_public_path__ + "img/red-edit.f1567195.svg";